import { dataResponse, errorCodeResponse, errorResponse } from './utils/response-templates.js';
import { documentConversionStatusSchema } from './documents.js';
import { ErrorCodes } from './error-codes.js';
import { z } from './utils/zod.js';
export const uploadPdfForConversionRequestSchema = z.object({
    file: z.instanceof(File),
});
export const pdfaConversionDtoSchema = z.object({
    id: z.string(),
    filename: z.string(),
    status: documentConversionStatusSchema,
});
export const uploadPdfForConversionResponseSchema = dataResponse(pdfaConversionDtoSchema);
export const pdfaConversionStatusResponseSchema = dataResponse(z.object({
    status: documentConversionStatusSchema,
    filename: z.string(),
}));
export const pdfaConversionNotFoundResponseSchema = errorCodeResponse(ErrorCodes.EDocumentNotFound, 'Conversion not found');
export const pdfaConversionInvalidFileResponseSchema = errorResponse('Only PDF files are allowed');
export const pdfaConversionNotReadyResponseSchema = errorCodeResponse(ErrorCodes.EDocumentNotReady, 'Conversion is not ready for download');
export const pdfaConversionRateLimitResponseSchema = errorCodeResponse(ErrorCodes.EPdfaConversionRateLimitReached, 'Daily PDF/A conversion limit reached');
